import { ValidationSchema, Tuple } from '../../../types';
import {
    textMandatory, isEmptyDate, IsValidDate, IsDateAfter1900AndBefore3000,
} from '../../validationFunctions';
import * as validatorRules from '../../validatorRules.json';
import { acceptedDateFormats, isDate } from '../../../components/input/dateComponents/util';
import moment from 'moment';
import { BusinessAuthorisationModel } from '../../../containers/manageAccess/types';
import { IsDateWithinThreeYearsInFuture } from '../createBusinessAuthorisation';

export const organisationRoleValidator: Tuple<(_value: any) => boolean, string>[] = [
    [textMandatory, validatorRules.BR1_Mandatory_Field.FieldMessage],
];

export const dateHasDate = (value: Date | undefined, _values: Partial<BusinessAuthorisationModel>) => {
    return !isEmptyDate(value);
};

export const dateIsValidDate = (value: Date | undefined) => {
    if (isEmptyDate(value) || value === undefined) {
        return true;
    }
    const formatToUse = acceptedDateFormats;
    return isDate(value, formatToUse);
};

export const dateRangeIsValid = (value: Date | undefined, values: Partial<BusinessAuthorisationModel>) => {
    if (!dateIsValidDate(values.startDate) || !dateIsValidDate(values.endDate) ||
            values.startDate === undefined || values.endDate === undefined) {
        return true;
    }
    return moment(values.startDate).toDate() <= moment(values.endDate).toDate(); // Regarded as a string in JS while running if we don't call moment
};

export const IsDateInFuture = (value: Date | undefined) => {
    // Already checked this
    if (value === undefined || !IsValidDate(value)) {
        return true;
    }

    const dateValue = moment(value).toDate();
    const dateNow = moment().startOf('day').toDate();
    return dateValue >= dateNow;
};

export const extendBusinessAuthorisation: ValidationSchema<Partial<BusinessAuthorisationModel>> = (values: Partial<BusinessAuthorisationModel>) => {
    return {
        startDate: [
            [value => dateHasDate(value, values), validatorRules.BR1_Mandatory_Field.FieldMessage],
            [value => dateIsValidDate(value), validatorRules.BR21_Date_Format.FieldMessage],
            [value => IsDateAfter1900AndBefore3000(value), validatorRules.BR148_DateMustBeValid.FieldMessage],
        ],
        endDate: [
            [value => dateHasDate(value, values), validatorRules.BR1_Mandatory_Field.FieldMessage],
            [value => dateIsValidDate(value), validatorRules.BR21_Date_Format.FieldMessage],
            [value => dateRangeIsValid(value, values), validatorRules.BR149_Date_Range_Start_End.FieldMessage],
            [value => IsDateInFuture(value), validatorRules.BR155_EndDateMustBeInTheFuture.FieldMessage],
            [value => IsDateWithinThreeYearsInFuture(value), validatorRules.BR150_EndDateMustNotBeThreeYearsInTheFuture.FieldMessage],
        ],
    };
};
